(function () {
    'use strict';

    angular
        .module('app.users')
        .controller('UserDetailsController', UserDetailsController);

    UserDetailsController.$inject = [
        '$state', '$stateParams',
        'bootstrap.dialog', 'common', 'config', 'dataservice', 'userService', 
    ];

    function UserDetailsController($state, $stateParams,
        bsDialog, common, config, dataservice, userService) {
        /*jshint validthis: true */
        var vm = this;
        var logger = common.logger;
        var $q = common.$q;
        vm.opsIncludeVersion = common.opsIncludeVersion;
        vm.cancel = cancel;
        vm.isSaving = false;
        vm.save = save;
        vm.item = undefined;
        vm.submitForm = submitForm;
        vm.isNew = isNew;
        vm.userTypes = [{ id:0, label: "Standard" }, { id:1, label : "Manager" }, { id:2, label : "Admin" }];
        vm.tenants = [];
        vm.tenantForUserCrud = {};
        vm.departments = [];
        vm.billingDepartments = [];
        vm.passwordPattern = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[ !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]).{12,}$/;
        vm.hasOps = common.userService.hasOps() == 1;
        vm.showFilters = common.userService.apiTypeId() !== common.config.apiTypes.centersXml;
        vm.showPassword = showPassword;
        vm.requirePassword = requirePassword;
        vm.currentPasswordRequired = false;

        activate();

        function activate() {
            var promises = [getItem(), getFilterTypes(), getTenants(), getTenantForUserCrud(),
                getDepartments(), getBillingDepartments()  ];
            return common.$q.all(promises).then(function (data) {

            }, function (error) { });
        }

        function submitForm(valid) {
            save();
        }

        function cancel() {
            backToList();
        }

        function backToList() {
            $state.go("users.list");
        }

        function isNew() {
            var val = $stateParams.id; 
            return val === "0";
        }

        function getItem() {
            var val = $stateParams.id;

            return dataservice.getItem("api/Users/" + val)
                .then(function (data) {
                    
                    if (data) {
                        vm.item = data.data;
                        if (!vm.item.FilterTypes) {
                            vm.item.FilterTypes = [];
                            if (common.userService.apiTypeId() === common.config.apiTypes.centersXml) {
                                vm.item.FilterTypes.push(0);
                            }
                        }
                        if (!vm.item.BillingDepartments) {
                            vm.item.BillingDepartments = [];
                        }

                        if (val === '0') {
                            vm.item.Departments = [];
                        }

                        common.setAuditInfo(vm.item);
                    } else {
                        logger.warning('Could not find item with id = ' + val);
                        $state.go('404');
                    }
                })
                .catch(function (error) {
                    logger.error('Error while getting item with id = ' + val + '; ' + error);
                    $state.go('404');
                });
        }

        function getFilterTypes() {
            return dataservice.getItems("api/FilterTypes/Active")
              .then(function (data) {
                  vm.filterTypes = data.data;
                }, function (error) { })
        }

        function getDepartments() {
            return dataservice.getItems("api/Departments/Active")
              .then(function (response) {
                  vm.departments = response.data;
                }, function (error) { })
        }

        function getTenants() {
            if (common.userService.tenantId() == 1) {
               dataservice.getItems("api/Tenants/SimpleGetAll").then(function (data) {
                  vm.tenants = data.data;
               }, function (error) { })
            }
        }

        function getTenantForUserCrud() {
            dataservice.getItems("api/Tenants/GetForUserCrud").then(function (data) {
                vm.tenantForUserCrud = data.data;
            }, function (error) { })
        }

        function getBillingDepartments() {
            dataservice.getItems("api/Users/BillingDepartments").then(function (response) {
                vm.billingDepartments = response.data;
            }, function (error) { })
        }

        function showPassword() {
            if (vm.tenantForUserCrud) {
                if (vm.tenantForUserCrud.ForceSso) {
                    return false;
                }

                return !hasSsoLogin();

            }
            return true;
        }

        function hasSsoLogin() {
            if (vm.item && vm.item.Logins) {
                for (var i = 0; i < vm.item.Logins.length; i++) {
                    if (vm.item.Logins[i].ProviderKey) {
                        return true;
                    }
                }
            }
            return false;
        }

        function requirePassword() {
            if (isNew()) {
                if (vm.tenantForUserCrud) {
                    if (vm.tenantForUserCrud.ForceSso) {
                        return false;
                    }
                    if (vm.tenantForUserCrud.SingleSignOn) {
                        return !hasSsoLogin();
                    }
                }
                return true;
            }
            else {
                return false;
            }
        }


        function save() {
            vm.isSaving = true;

            if (vm.item.FilterTypes.length == 0 && userService.hasOps() == "1") {
                logger.error("User must have at least one filter", "", "Error");
                return;
            }

            dataservice.saveItem('api/Users/Save', vm.item, true).then(function (saveResult) {
                vm.isSaving = false;
                var result = saveResult.data;
                if (result.Succeeded) {
                    backToList();
                }
                else {
                    var errors = "";
                    for (var i = 0; i < result.Errors.length; i++) {
                        errors += result.Errors[i] + "\n";
                    }
                    logger.error(errors, "", "Error");
                }

            }).catch(function (error) {
                vm.isSaving = false;
            });
        }
    }
})();
